// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../../../shared-browser/src/BrowserStyle.bs.js");
var BrowserComponents_Card = require("../../../shared-browser/src/components/BrowserComponents_Card.bs.js");
var BrowserComponents_Icon = require("../../../shared-browser/src/components/BrowserComponents_Icon.bs.js");
var BrowserComponents_Text = require("../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Image = require("../../../shared-browser/src/components/BrowserComponents_Image.bs.js");
var BrowserComponents_Button = require("../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexColumn = require("../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var BrowserComponents_AlertCountIndicator = require("../../../shared-browser/src/components/BrowserComponents_AlertCountIndicator.bs.js");

var card = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.flexDirection(BrowserStyle.row),
        tl: /* [] */0
      }
    });

var detailsContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.flexStart),
      tl: {
        hd: BrowserStyle.flex({
              NAME: "num",
              VAL: 1.0
            }),
        tl: /* [] */0
      }
    });

function arg(param) {
  return BrowserStyle.withFont(param, /* Quicksand */0, /* XLarge */5, /* Semibold */1);
}

var title = Curry._1(BrowserStyle.style, Curry._1(arg(undefined), /* [] */0));

var description = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Small */2, undefined)({
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Medium */2
              }),
          tl: {
            hd: BrowserStyle.textAlign("left"),
            tl: /* [] */0
          }
        }));

var illustration = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flexShrink(0.0),
      tl: {
        hd: BrowserStyle.height(BrowserStyle.rem(4.0)),
        tl: {
          hd: BrowserStyle.width(BrowserStyle.rem(4.0)),
          tl: /* [] */0
        }
      }
    });

var Styles = {
  card: card,
  detailsContainer: detailsContainer,
  title: title,
  description: description,
  illustration: illustration
};

function WebComponents_ToDoTaskCard(Props) {
  var alertCount = Props.alertCount;
  var className = Props.className;
  var description$1 = Props.description;
  var illustration$1 = Props.illustration;
  var onClick = Props.onClick;
  var title$1 = Props.title;
  var tmp = {
    children: React.createElement(BrowserComponents_Card.make, {
          className: card,
          children: null
        }, React.createElement(BrowserComponents_Image.make, {
              className: illustration,
              image: {
                TAG: /* Illustration */1,
                _0: illustration$1
              }
            }), React.createElement(BrowserComponents_Spacer.make, {
              size: /* Large */5
            }), React.createElement(BrowserComponents_FlexColumn.make, {
              className: detailsContainer,
              children: null
            }, React.createElement(BrowserComponents_Text.make, {
                  className: title,
                  children: title$1
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Small */3
                }), React.createElement(BrowserComponents_Text.make, {
                  className: description,
                  children: description$1
                })), Curry._2(Relude_Int.OrdNamed.greaterThan, 0, alertCount) ? React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                    size: /* Small */3
                  }), React.createElement(BrowserComponents_AlertCountIndicator.make, {
                    alertCount: alertCount
                  })) : null, React.createElement(BrowserComponents_Spacer.make, {
              size: /* Small */3
            }), React.createElement(BrowserComponents_Icon.make, {
              color: {
                TAG: /* Grey */2,
                _0: /* Medium */2
              },
              icon: {
                TAG: /* Small */1,
                _0: {
                  TAG: /* Arrow */0,
                  _0: /* ChevronRight */12
                }
              },
              size: /* Large */3
            })),
    onClick: (function (param) {
        return onClick;
      })
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement(BrowserComponents_Button.Base.make, tmp);
}

var make = WebComponents_ToDoTaskCard;

exports.Styles = Styles;
exports.make = make;
/* card Not a pure module */
